import { createContext, useContext, useEffect, useState } from "react";

// Simple readability switch: English (default) | Hinglish (Roman Hindi).
// t() maps an exact English UI string to its Hinglish version; anything not
// mapped falls back to English. Brand names, numbers and prices stay as-is.
// User-generated profile content is never translated.

const LANG_KEY = "suffa_lang";

const LanguageContext = createContext(null);

export const HINGLISH = {
  // Header / nav
  "Find Matches": "Rishta Dhundo",
  "My Profile": "Mera Profile",

  // Hero
  "“And We created you in pairs.”": "“Aur Humne tumhein jodon mein paida kiya.”",

  // Footer
  "A trusted Muslim matrimonial service — for serious and halal rishtas.":
    "Ek trusted Muslim matrimonial service — serious aur halal rishtey ke liye.",

  // Contact page
  "Contact Us": "Contact Karein",
  "Our team is happy to guide you through your search for a blessed partnership.":
    "Hamari team aapko behtareen rishta dhoondhne mein khushi se guide karegi.",
  "Call Us": "Call Karein",
  "Tap to call our team": "Team ko call karne ke liye tap karein",
  "Email Us": "Email Karein",
  "Tap to write to us": "Email likhne ke liye tap karein",

  // Login
  "Welcome Back": "Wapas Aayein",
  "Sign in to your Suffa Matrimony account.": "Apne Suffa Matrimony account mein sign in karein.",
  "Sign-in is being prepared and will open shortly, insha’Allah. Thank you for your patience.":
    "Login ki process taiyaar ho rahi hai, thodi der mein khul jayega, insha’Allah. Aapke sabr ka shukriya.",
  "Your password": "Aapka password",
  "Remember me": "Mujhe yaad rakhein",
  "Forgot Password?": "Password Bhool Gaye?",
  "Don’t have an account?": "Account nahi hai?",
  "Create an Account": "Naya Account Banayein",
  "Back to Home": "Home Par Jaayein",

  // Profile completion & ₹500 registration fee (Contact Fees section)
  "Profile Completed": "Profile Complete Ho Gayi",
  "Your profile has been completed and saved securely to your Suffa Matrimony account.":
    "Aapki profile complete ho kar aapke Suffa Matrimony account mein surakshit save ho gayi hai.",
  "One-time Profile Registration Fee: ₹500": "Profile Registration Fee (sirf ek baar): ₹500",
  "Registration Fee: ₹500": "Registration Fee: ₹500",
  "Pending": "Pending",
  "Paid": "Payment Ho Gaya",
  "Failed": "Fail Ho Gaya",
  "Fee Waived": "Fee Maaf",
  "Payment Successful — thank you! Your profile is now pending admin approval.":
    "Payment Successful — shukriya! Aapki profile ab admin approval ke liye pending hai.",
  "Fee Waived — the ₹500 registration fee was waived by Suffa Matrimony. No payment is required.":
    "Fee Maaf — ₹500 ka registration fee Suffa Matrimony ne maaf kar diya hai. Ab koi payment nahi karna hai.",
  "Payment failed. Please try again.": "Payment fail ho gaya. Meherbani karke dobara koshish karein.",
  "Browsing is free. This one-time ₹500 fee submits your profile for admin approval. Your profile becomes visible in Find Matches only after the fee is paid (or officially waived) and an admin approves it.":
    "Profile dekhna aur search karna free hai. Yeh one-time ₹500 fee aapki profile ko admin approval ke liye submit karta hai. Aapki profile Find Matches mein tabhi dikhegi jab yeh fee paid (ya officially waived) ho jaye aur admin use approve kar de.",
  "Pay ₹500": "₹500 Pay Karein",
  "Pending Verification": "Verification ke liye Pending",
  "Submit for Verification": "Verification ke liye Submit Karein",
  "Submitting…": "Submit ho raha hai…",
  "Pay via UPI QR": "UPI QR se Pay Karein",
  "Open any UPI app (GPay / PhonePe / Paytm), scan this QR and pay exactly ₹500. Then enter the 12-digit UPI transaction reference number (UTR) shown in your payment receipt below.":
    "Koi bhi UPI app (GPay / PhonePe / Paytm) kholein, yeh QR scan karke theek ₹500 ka payment karein. Phir apne payment receipt mein dikhne wala 12-digit UPI transaction reference number (UTR) neeche enter karein.",
  "UPI ID:": "UPI ID:",
  "Enter UTR (UPI reference number)": "UTR (UPI reference number) enter karein",
  "Your payment is submitted and awaiting verification. Our team will confirm it shortly, insha'Allah.":
    "Aapka payment submit ho gaya hai aur verification ka intezaar hai. Hamari team jaldi hi confirm karegi, insha'Allah.",
  "Payment rejected:": "Payment reject kiya gaya:",
  "Please pay again and submit a fresh UTR, or contact support.": "Meherbani karke dobara payment karke naya UTR submit karein, ya support se rabta karein.",
  "UPI payment is being set up. Please contact support to pay the ₹500 registration fee.":
    "UPI payment setup ho raha hai. ₹500 registration fee ke liye meherbani karke support se rabta karein.",
  "Pay exactly ₹500 to": "Theek ₹500 ka payment karein:",
  "Pay ₹500 Again": "Dobara ₹500 Pay Karein",
  "Registration Fee: ₹400": "Registration Fee: ₹400",
  "One-time Profile Registration Fee: ₹400": "Profile Registration Fee (sirf ek baar): ₹400",
  "Pay exactly ₹400 to": "Theek ₹400 ka payment karein:",
  "Open any UPI app (GPay / PhonePe / Paytm), scan this QR and pay exactly ₹400. Then enter the 12-digit UPI transaction reference number (UTR) shown in your payment receipt below.":
    "Koi bhi UPI app (GPay / PhonePe / Paytm) kholein, yeh QR scan karke theek ₹400 ka payment karein. Phir apne payment receipt mein dikhne wala 12-digit UPI transaction reference number (UTR) neeche enter karein.",
  "Scan the QR using Google Pay, PhonePe or any UPI app and pay exactly ₹400. Then enter the UTR / UPI Transaction ID shown in your payment app receipt below.":
    "Google Pay, PhonePe ya kisi bhi UPI app se QR scan karke theek ₹400 ka payment karein. Phir apne payment app ke receipt mein dikhne wala UTR / UPI Transaction ID neeche enter karein.",
  "Scan the QR using Google Pay, PhonePe or any UPI app and pay exactly ₹500. Then enter the UTR / UPI Transaction ID shown in your payment app receipt below.":
    "Google Pay, PhonePe ya kisi bhi UPI app se QR scan karke theek ₹500 ka payment karein. Phir apne payment app ke receipt mein dikhne wala UTR / UPI Transaction ID neeche enter karein.",
  "Payment submitted – Awaiting admin verification. Our team will confirm the credit in the bank account shortly, insha'Allah.":
    "Payment submit ho gaya – Admin verification ka intezaar. Hamari team bank account mein credit ki tasdeeg jaldi karegi, insha'Allah.",
  "The payment will appear as paid to": "Payment is naam se jayega:",
  "our current QR is temporary and will be replaced by a Suffa Matrimony merchant QR later.":
    "hamara current QR temporary hai — baad mein iski jagah Suffa Matrimony merchant QR lag jayega.",
  "Payer name on UPI app (optional)": "UPI app par payer ka naam (optional)",
  "Pay ₹400 with UPI": "UPI se ₹400 Pay Karein",
  "Pay ₹500 with UPI": "UPI se ₹500 Pay Karein",
  "Copy UPI ID": "UPI ID Copy Karein",
  "Copied!": "Copy ho gaya!",
  "Nothing opened? Your phone may have no UPI app — scan the QR or copy the UPI ID, pay from another phone, then submit the UTR here.":
    "Kuch khula nahi? Shayad aapke phone mein UPI app nahi hai — QR scan karein ya UPI ID copy karein, doosre phone se pay karein, phir UTR yahan submit karein.",
  "Browsing is free. This one-time ₹400 fee submits your profile for admin approval. Your profile becomes visible in Find Matches only after the fee is verified and an admin approves it.":
    "Profile dekhna aur search karna free hai. Yeh one-time ₹400 fee aapki profile ko admin approval ke liye submit karta hai. Aapki profile Find Matches mein tabhi dikhegi jab yeh fee paid ho jaye aur admin use approve kar de.",
  "UPI payment is being set up. Please contact support to pay the ₹400 registration fee.":
    "UPI payment setup ho raha hai. ₹400 registration fee ke liye meherbani karke support se rabta karein.",
  "Grand Launch Offer": "Grand Launch Offer",
  "20% off profile registration": "Profile registration par 20% off",
  "Valid 25 Oct – 24 Nov 2026": "25 Oct – 24 Nov 2026 tak valid",
  "Create Profile": "Profile Banayein",
  "Regular fee": "Regular fee",
  "Launch discount (20%)": "Launch discount (20%)",
  "Payable now": "Ab jama karein",
  "Serving Surat & Nearby Muslim Families — Find Meaningful Rishtas for Nikah.":
    "Surat aur aas-pas ke Muslim parivaron ke liye — Nikah ke liye khaas Rishtay.",
  "Surat • Navsari • Bharuch • Ankleshwar • Bardoli • Valsad — and members welcome worldwide":
    "Surat • Navsari • Bharuch • Ankleshwar • Bardoli • Valsad — aur duniya bhar se members",
  "Grand Launch Offer: 20% off registration — ₹400 instead of ₹500, valid through 24 November 2026.":
    "Grand Launch Offer: registration par 20% off — ₹500 nahi, sirf ₹400, 24 November 2026 tak.",
  "Rooted in Surat": "Surat se, aapke liye",
  "Serving families across South Gujarat & beyond": "South Gujarat aur aage tak — parivaron ki seva mein",
  "Families in Surat and nearby towns trust Suffa Matrimony to guide rishtas for Nikah with care, dignity and personal admin oversight — and members join us from around the world. Browse profiles free and register in minutes.":
    "Surat aur nazdeeki sheheron ke parivar Suffa Matrimony par bharosa karte hain — care, izzat aur personal admin review ke saath Nikah ke rishtay. Duniya bhar se members shamil hain. Profiles free dekhein aur minutes mein register karein.",
  "Register Profile": "Profile Register Karein",
  "Worldwide members": "Duniya bhar ke members",
  "Pay ₹500 & Submit Profile": "₹500 Pay Karein & Profile Submit Karein",
  "Opening payment…": "Payment khul raha hai…",
  "Complete your profile to see your registration fee status.":
    "Apne registration fee ka status dekhne ke liye pehle apni profile complete karein.",
  "Could not load the payment gateway. Please check your connection and try again.":
    "Payment gateway load nahi ho paya. Meherbani karke apna connection check karke dobara koshish karein.",
  "Browse profiles for free. Profile registration fee: ₹500 one-time. If a marriage is successfully finalized through Suffa Matrimony, a Successful Match Service Fee of ₹5,000–₹10,000 applies separately to each side. The applicable fee will be communicated and agreed upon before payment.":
    "Profiles dekhna muft hai. Profile registration fee: ₹500 sirf ek baar. Agar Suffa Matrimony ke through koi rishta final ho jata hai, to Successful Match Service Fee ₹5,000–₹10,000 alag-alag har side par lagti hai. Payment lene se pehle applicable fee confirm aur agree ki jayegi.",
  "Please enter your email address.": "Apna email address enter karein.",
  "Please enter a valid email address.": "Sahi email address enter karein.",
  "Please enter your password.": "Apna password enter karein.",

  // Register
  "Create Your Suffa Matrimony Account": "Apna Suffa Matrimony Account Banayein",
  "Begin your journey towards a meaningful marriage.":
    "Ek behtareen rishte ki taraf apna safar shuru karein.",
  "Who is this profile for?": "Ye profile kiske liye hai?",
  "Please select who this profile is for.": "Select karein ye profile kiske liye hai.",
  "Please enter your full name.": "Apna poora naam enter karein.",
  "Please enter your full name (at least 3 characters).":
    "Apna poora naam enter karein (kam se kam 3 characters).",
  "Please enter your mobile number.": "Apna mobile number enter karein.",
  "Enter your complete current address": "Apna poora mojooda residential address likhein",
  "Full Current Address": "Poora Mojooda Pata",
  "Parent / Wali Name": "Parent / Wali Ka Naam",
  "Enter Parent / Wali name": "Parent / Wali ka naam likhein",
  "Please enter your full current address.": "Apna poora mojooda address likhein.",
  "Please enter Parent / Wali name.": "Parent / Wali ka naam likhein.",
  "Please select the relationship.": "Relationship chunein.",
  "Please enter Parent / Wali mobile number.": "Parent / Wali mobile number likhein.",
  "Please enter a valid Parent / Wali mobile number (8–15 digits).":
    "Sahi Parent / Wali mobile number likhein (8–15 digits).",
  "Please enter a valid mobile number (8–15 digits).": "Sahi mobile number enter karein (8–15 digits).",
  "Please enter the mobile number.": "Apna mobile number enter karein.",
  "Please enter the email address.": "Apna email address enter karein.",
  "Please enter a valid email address.": "Sahi email address enter karein.",
  "Please select the preferred contact method.": "Pasandeeda contact method chunein.",
  "Please create a password.": "Password banayein.",
  "Password must be at least 8 characters.": "Password kam se kam 8 characters ka hona chahiye.",
  "Please confirm your password.": "Password confirm karein.",
  "Passwords do not match.": "Password match nahi kar rahe.",
  "Please agree to the Terms & Conditions and Privacy Policy.":
    "Kripya Terms & Conditions aur Privacy Policy par tick lagayein.",
  "Full Name": "Poora Naam",
  "Full name": "Poora naam",
  "At least 8 characters": "Kam se kam 8 characters",
  "Re-enter your password": "Password dobara likhein",
  "Confirm Password": "Password Confirm Karein",
  "Create Account": "Account Banayein",
  "Already have an account?": "Pehle se account hai?",
  "I agree to the": "Main",
  "and": "aur",
  "se sehmat hoon.": "se sehmat hoon.",

  // Find Matches
  "Find Your Life Partner": "Apne Life Partner Ko Dhoondhein",
  "Explore Muslim matrimonial profiles and discover a suitable match for marriage.":
    "Muslim matrimonial profiles dekhein aur apne liye behtareen rishta dhoondhein.",
  "profile matches your search": "profile aapki search se match hui",
  "profiles match your search": "profiles aapki search se match hue",
  "No matching profiles found": "Koi matching profile nahi mili",
  "Try widening the age range or clearing a filter or two.":
    "Umar ki range badha kar dekhein ya ek-do filters hata kar dekhein.",
  "Clear Filters": "Filters Hataayein",
  "Search Matches": "Matches Dhundo",
  "More Filters": "Aur Filters",
  "Looking For": "Kis Ke Liye",
  "Age From": "Umar Se",
  "Age To": "Umar Tak",
  "Any": "Koi Bhi",
  "All Countries": "Sabhi Countries",
  "State / Province (Optional)": "State / Province (Zaroori Nahi)",
  "Any state / province": "Koi bhi state / province",
  "City (Optional)": "City (Zaroori Nahi)",
  "Any city": "Koi bhi city",
  "Education (Optional)": "Education (Zaroori Nahi)",
  "Any Education": "Koi bhi Education",
  "Profession (Optional)": "Profession (Zaroori Nahi)",
  "Any Profession": "Koi bhi Profession",
  "Marital Status": "Marital Status",
  "Any Marital Status": "Koi bhi Marital Status",
  "Religious / Personal Preferences (Optional)": "Religious / Personal Preferences (Zaroori Nahi)",
  "Height From (cm)": "Lambai Se (cm)",
  "Height To (cm)": "Lambai Tak (cm)",
  "Family background and further preferences are coming soon, insha’Allah.":
    "Family background aur baaki preferences jald aa rahe hain, insha’Allah.",

  // Profile card / modal / dialog
  "Photo private · On request": "Photo private · Request par",
  "View Profile": "Profile Dekhein",
  "Interested?": "Pasand Hai?",
  "Interested": "Pasand Hai?",
  "Age / Date of Birth": "Umar / Date of Birth",
  "Age": "Umar",
  "Born": "Janam",
  "(shared with permission)": "(ijazat ke saath share kiya gaya)",
  "Height": "Lambai",
  "Contact details are never shown publicly. Connections are made only through Suffa Matrimony, with family and dignity, insha’Allah.":
    "Contact details kabhi publicly nahi dikhaye jate. Rishta sirf Suffa Matrimony ke through, family aur izzat ke saath, insha’Allah.",
  "Close": "Band Karein",
  "Interested in this profile?": "Ye Profile Pasand Aayi?",
  "Contact Suffa Matrimony and our team will guide you through the next step.":
    "Suffa Matrimony ko contact karein — hamari team aage guide karegi.",
  "Request received — our team will guide you through the next step.":
    "Request mil gayi — hamari team aage guide karegi.",
  "will reach out shortly, insha’Allah.": "ke baare mein jald contact karegi, insha’Allah.",

  // Create profile — chrome
  "Create Your Matrimony Profile": "Apna Matrimony Profile Banayein",
  "Tell us about yourself and what you are looking for in a life partner.":
    "Apne bare mein batayein — aap kis tarah ka life partner dhoondh rahe hain.",
  "of": "/",
  "We restored your saved draft.": "Aapka saved draft wapas restore kar liya hai.",
  "Start over": "Naye Se Shuru Karein",
  "Continue": "Aage Badhein",
  "Back": "Wapas",
  "Submit Profile": "Profile Submit Karein",
  "Your progress is saved automatically on this device only — nothing is shared until you submit.":
    "Aapki progress apne aap isi device par save hoti hai — submit karne tak kuch share nahi hota.",
  "(optional)": "(zaroori nahi)",
  "selected": "select kiya",
  "Select": "Chunein",
  "Type to search…": "Type karke dhoondein…",
  "No matches found": "Koi match nahi mila",

  // Step titles
  "Profile For": "Profile Kis Ke Liye",
  "Basic Information": "Buniyadi Maloomat",
  "Religious Information": "Deeni Maloomat",
  "Marriage Preferences": "Rishte Ki Pasand",

  // Step 1 / 2 labels
  "Myself": "Apne Liye",
  "My Son": "Mere Bethe",
  "My Daughter": "Meri Beti",
  "My Brother": "Mere Bhai",
  "My Sister": "Meri Behen",
  "Age is calculated automatically from the date of birth.":
    "Umar date of birth se apne aap calculate hoti hai.",
  "Select Country": "Country Chunein",
  "Select a country first": "Pehle country select karein",
  "Select a state / province first": "Pehle state / province select karein",
  "Select City": "City Chunein",
  "Enter city": "City likhein",
  "Select Nationality": "Nationality Chunein",
  "Select Community / Jamaat": "Community / Jamaat Chunein",
  "Enter your Community / Jamaat": "Apni Community / Jamaat likhein",

  // Step: Religious Information
  "Religious Background — Select all that apply": "Religious Background — Jo Lagu Ho Wo Sab Chunein",
  "School of Thought / Religious Affiliation — Select all that apply":
    "School of Thought / Religious Affiliation — Jo Lagu Ho Wo Sab Chunein",
  "Select School of Thought / Religious Affiliation": "School of Thought / Affiliation Chunein",
  "Enter your School of Thought / Religious Affiliation":
    "Apna School of Thought / Religious Affiliation likhein",
  "e.g. Barelvi tradition of a particular Khanqah": "jaise kisi khaas Khanqah ka tareeqa",
  "Please specify your religious practice": "Apni religious practice likhein",
  "Describe your religious practice in your own words": "Apne alfazon mein likhein",
  "Please enter your school of thought / religious affiliation.":
    "Apna school of thought / religious affiliation likhein.",
  "Please specify your religious practice.": "Apni religious practice likhein.",

  // Step: Lifestyle
  "Height (cm)": "Lambai (cm)",
  "Weight (kg)": "Wazan (kg)",
  "Complexion / Skin Tone": "Rang / Complexion",
  "Enter your Complexion / Skin Tone": "Apna rang / complexion likhein",
  "Describe your complexion in your own words": "Apne alfazon mein likhein",
  "Languages — Select all that apply": "Languages — Jo Lagu Ho Wo Sab Chunein",
  "Select Languages": "Languages Chunein",
  "Enter your language": "Apni language likhein",
  "Hobbies & Interests": "Shauq & Dilchaspi",
  "Tell us about your hobbies, interests and activities you enjoy...":
    "Apne shauq, interests aur pasandeeda activities ke bare mein batayein...",
  "Please enter a height between 120 and 210 cm.": "Lambai 120 se 210 cm ke beech likhein.",
  "Please enter a weight between 20 and 300 kg.": "Wazan 20 se 300 kg ke beech likhein.",
  "Please enter your complexion / skin tone.": "Apna rang / complexion likhein.",
  "Please enter your language.": "Apni language likhein.",

  // Step: Family
  "Father’s Occupation": "Walid Ka Kaam",
  "Father’s occupation": "Walid ka kaam",
  "Mother’s Occupation": "Walida Ka Kaam",
  "Mother’s occupation": "Walida ka kaam",
  "Siblings": "Bhai Behen",
  "e.g. 1 brother, 2 sisters": "jaise 1 bhai, 2 behen",
  "Family Location": "Family Ki Location",
  "Brief Family Introduction": "Family Ka Mukhtasir Taaruf",
  "A few lines about your family.": "Apne family ke bare mein kuch lines.",

  // Step: Marriage Preferences
  "Preferred Age From": "Umar Se",
  "Preferred Age To": "Umar Tak",
  "Preferred Country / Location": "Pasandeeda Country / Location",
  "Select or add countries / locations": "Countries / locations chunein ya likhein",
  "Preferred Marital Status": "Pasandeeda Marital Status",
  "Select Preferred Marital Status": "Marital Status Chunein",
  "Preferred Education": "Pasandeeda Education",
  "e.g. Graduate or above": "jaise Graduate ya usse upar",
  "Preferred Profession": "Pasandeeda Profession",
  "e.g. Doctor, Teacher — or leave open": "jaise Doctor, Teacher — ya khali chhod dein",
  "Religious Preferences": "Deeni Pasand",
  "Preferred Height": "Pasandeeda Lambai",
  "e.g. 5 ft 4 in and above": "jaise 5 ft 4 in aur upar",
  "What I am looking for in my life partner": "Main apne life partner mein kya dekhna chahta/chahti hoon",
  "Describe the person you hope to share your life with — character, faith, nature and dreams.":
    "Apne future partner ke bare mein likhein — character, deen, fitrat aur khwab.",
  "Please select the preferred age from.": "Umar (se) chunein.",
  "Please select the preferred age to.": "Umar (tak) chunein.",
  "Preferred age to should be greater than age from.":
    "Umar (tak) ko Umar (se) se bada hona chahiye.",
  "Please select at least one preferred country / location.":
    "Kam se kam ek pasandeeda country / location chunein.",
  "Please select at least one preferred marital status.":
    "Kam se kam ek pasandeeda marital status chunein.",

  // Step: Photos / Contact
  "Private — not publicly displayed": "Private — publicly nahi dikhega",
  "Private — never shown publicly.": "Private — kabhi publicly nahi dikhta.",
  "Private — never shown on your public profile.": "Private — aapki public profile par kabhi nahi dikhega.",
  "Shown publicly as Age": "Publicly sirf Umar",

  // Create profile validation (remaining)
  "Please choose who this profile is for.": "Chunein ye profile kiske liye hai.",
  "Please enter the full name (at least 3 characters).": "Poora naam enter karein (kam se kam 3 characters).",
  "Please select the gender.": "Gender chunein.",
  "Please provide the complete date of birth (day, month and year).":
    "Poori date of birth provide karein.",
  "Please provide a valid date of birth — it cannot be in the future.":
    "Sahi date of birth provide karein — future ki date nahi ho sakti.",
  "Profiles can be created for adults aged 18 and above.":
    "Profile sirf 18 saal ya usse zyada age ke adults ke liye ban sakti hai.",
  "Please select a country.": "Country chunein.",
  "Please select a state / province.": "State / province chunein.",
  "Please select the state / province.": "State / province chunein.",
  "Please select the city.": "City chunein.",
  "Please select the nationality.": "Nationality chunein.",
  "Please enter your community / jamaat.": "Apni community / jamaat likhein.",
  "Please select the marital status.": "Marital status chunein.",
  "Please select the number of children.": "Children ki tadaad chunein.",
  "Please select your school education.": "School education chunein.",
  "Please enter your school education.": "Apni school education likhein.",
  "Please select your madarsa education.": "Madarsa education chunein.",
  "Please enter your madarsa education.": "Apni madarsa education likhein.",
  "Please select the profession.": "Profession chunein.",
  "Please enter your profession.": "Apna profession likhein.",

  // Submission success
  "Profile Submitted": "Profile Submit Ho Gayi",

  // Accounts, profiles & Find Matches (backend-connected)
  "Logout": "Logout",
  "Loading…": "Load ho raha hai…",
  "Loading profiles…": "Profiles load ho rahi hain…",
  "Signing in…": "Sign in ho raha hai…",
  "Creating account…": "Account ban raha hai…",
  "Submitting…": "Submit ho raha hai…",
  "Login Required": "Login Zaroori Hai",
  "Your matrimonial profile is saved securely with your Suffa Matrimony account. Please login or create an account to continue.":
    "Aapki matrimonial profile aapke Suffa Matrimony account ke saath mehfooz rehti hai. Aage badhne ke liye login karein ya naya account banayein.",
  "Incorrect email or password.": "Email ya password galat hai.",
  "This email is already registered. Please login.":
    "Ye email pehle se registered hai. Kripya login karein.",
  "Too many failed attempts. Please try again in 15 minutes.":
    "Bahut zyada galat koshishen. Meherbani karke 15 minute baad phir koshish karein.",
  "Something went wrong. Please try again.":
    "Kuch ghalat ho gaya hai. Meherbani karke dobara koshish karein.",
  "Your progress is saved as you complete your profile. Your submitted profile is securely stored with your account and shown in Find Matches only after it passes Suffa Matrimony's approval and privacy rules.":
    "Aapki progress profile complete karne ke saath save hoti jaati hai. Submit ki gayi profile aapke account ke saath mehfooz rehti hai aur Suffa Matrimony ke approval aur privacy rules pass karne ke baad hi Find Matches mein dikhti hai.",
  "Profile Submitted": "Profile Submit Ho Gayi",
  "Your profile has been submitted and saved securely to your Suffa Matrimony account.":
    "Aapki profile submit ho gayi hai aur aapke Suffa Matrimony account ke saath mehfooz tareeqe se save ho gayi hai.",
  "It will appear in Find Matches for other members, subject to Suffa Matrimony's approval and privacy rules. Our team will reach out to you on your preferred contact method, insha’Allah.":
    "Ye doosre members ko Find Matches mein, Suffa Matrimony ke approval aur privacy rules ke mutabiq dikhegi. Hamari team aapse aapki pasandeeda contact method par rabta karegi, insha’Allah.",
  "Go to My Profile": "Mera Profile Dekhein",
  "Edit Profile": "Profile Edit Karein",
  "Profile ID": "Profile ID",
  "Active": "Active",
  "Pending review": "Review mein hai",
  "You haven't completed your profile yet.": "Aapne abhi apni profile complete nahi ki hai.",
  "Your matrimonial profile — securely saved with your Suffa Matrimony account.":
    "Aapki matrimonial profile — aapke Suffa Matrimony account ke saath mehfooz.",
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      return localStorage.getItem(LANG_KEY) === "hinglish" ? "hinglish" : "english";
    } catch (e) {
      return "english";
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(LANG_KEY, lang);
    } catch (e) {
      /* storage unavailable */
    }
  }, [lang]);

  const t = (en) => (lang === "hinglish" ? HINGLISH[en] || en : en);

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
